import './Light.css'
import { Button } from '@mui/material'
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper'
import { useEffect, useState } from 'react';
// ICONs & SVGs
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import lightIcon from '../../imgs/light_img.svg'

import IconButton from '@mui/material/IconButton';
import CircleIcon from '@mui/icons-material/Circle';

import axios from "axios";
import { useSnackbar } from "notistack";
import { useHistory } from 'react-router';
function Light(props) {

    const { enqueueSnackbar } = useSnackbar();
    const auth = localStorage.getItem("authToken");
    const user_id = localStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);
    const [allAreas, setAllAreas] = useState([])
    const isloggedin = localStorage.getItem("loggedIn");
    useEffect(() => {
        if(!isloggedin)
        {
            history.push('/login'); 
            window.location.reload(); 
        }
    }, []);
    useEffect(() => {
        if(props.location.state.subadmin === 'all'){
            fetchAllAreas();
        }
        else{
            let array1 = props.location.state.user;
            for (let index = 0; index < array1.length; index++) {
                const element = array1[index];
                if(element.name === props.location.state.subadmin)
                {
                    // console.log(element);
                    setAllAreas([element]);
                    break;
                }
            }
        }
    }, [])
    // console.log(props.location.state);
    const fetchAllAreas = async () => {
        setLoading(true);
        let url = '';
        if((localStorage.getItem("role") === "admin")){
            url = '/admin/areas/all';
        }
        else{
            url = '/admin/areas/subadmin';
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}${url}`, { user_id }, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
                setAllAreas(res.data.areas);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
            })
    }
    const history = useHistory();
    const onBackClick = () => {
        history.push('/dashboard');
        // window.location.reload();
    }
    const pop = (area_id) => {
        history.push(`/devicelight/${area_id}`, props.location.state);
    };

    return (
        <IonicPageWrapper onBackClick={onBackClick} headerTitle='Areas' showLogout={true}>
            <div id="lightsControl">
                <div className="lights_cardCont">
                    {allAreas.map((area, index) => (
                        <LightsCard
                            key={index}
                            no_device={area.area_id}
                            area={area.area_name}
                            click={() => pop(area.area_id)}
                        />
                    ))}
                    {/* <LightsCard no_device="20 Devices" area="Area 1" click={pop} />
                    <LightsCard no_device="30 Devices" area="Area 2" click={pop} />
                    <LightsCard no_device="40 Devices" area="Area 3" click={pop} />
                    <LightsCard no_device="50 Devices" area="Area 4" click={pop} />
                    <LightsCard no_device="60 Devices" area="Area 5" click={pop} />
                    <LightsCard no_device="70 Devices" area="Area 6" click={pop} /> */}
                </div>
            </div>
        </IonicPageWrapper>
    )
}

export default Light

const LightsCard = ({ no_device, area, click }) => (
    <div className="lights_card" onClick={click}>

        <section className='lights_card_content'>
            <img src={lightIcon} alt="" />
            <p className='lights_card_device'>{no_device}</p>
            <p className='lights_card_area'>{area}</p>
        </section>

        <section className="lights_card_btnsCont">
            {/* <IconButton aria-label="delete" size="small">
                <CircleIcon fontSize="small" sx={{ color: 'red !important' }} />
            </IconButton>
            <IconButton aria-label="delete" size="small">
                <CircleIcon fontSize="small" sx={{ color: 'yellow !important' }} />
            </IconButton>
            <IconButton aria-label="delete" size="small">
                <CircleIcon fontSize="small" sx={{ color: '#fff !important' }} />
            </IconButton>
            <IconButton aria-label="delete" size="small">
                <PowerSettingsNewIcon fontSize="small" sx={{ color: '#fff !important' }} />
            </IconButton> */}
            {/* <Button variant='contained' sx={{ backgroundColor: 'red !important' }} />
            <Button variant='contained' sx={{ backgroundColor: 'yellow !important' }} />
            <Button variant='contained' sx={{ backgroundColor: '#fff !important' }} /> */}
            {/* <PowerSettingsNewIcon className='lights_card_closeIcon' /> */}
        </section>
    </div>
)